import { render, staticRenderFns } from "./topic_set_by.vue?vue&type=template&id=c554f522&"
import script from "./topic_set_by.vue?vue&type=script&lang=js&"
export * from "./topic_set_by.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports